import React from 'react';
import { shallowEqual, useSelector } from 'umi';
import CommonPageRender from '@/pages/dashboard/components/PageContainer/CommonPageRender';
import '@/pages/dashboard/assets/scss/page/Overlay/newDaily.scss';
import { IDataFrame, ISelectorState } from '@/pages/dashboard/types/dashboard';
import { casualPageConfig } from '@/pages/dashboard/pages/eventAnalysis/EventExploration/casualPageConfig';
import { IPageConfigType } from '@/pages/dashboard/components/PageContainer/type';

const reqParams = '/eventAnalysis/eventExploration';

const pageMap: Partial<Record<IDataFrame, IPageConfigType>> = {
  casual: casualPageConfig as unknown as IPageConfigType,
};

const EventAnalysis = () => {
  const dataFrame = useSelector((state: ISelectorState) => {
    return state?.dashboard?.currentGame?.data_frame || 'casual';
  }, shallowEqual);

  return (
    <CommonPageRender
      reqParams={reqParams}
      pageConfigInit={pageMap?.[dataFrame]}
    />
  );
};

export default EventAnalysis;